import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import { getSizeChannel, POSITION_SCALE_CHANNELS } from '../../channel';
import { isContinuousFieldOrDatumDef } from '../../channeldef';
import * as log from '../../log';
import { isStep } from '../../spec/base';
export function initLayoutSize(_ref) {
  var encoding = _ref.encoding,
      size = _ref.size;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = POSITION_SCALE_CHANNELS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var channel = _step.value;
      var sizeType = getSizeChannel(channel);

      if (isStep(size[sizeType])) {
        if (isContinuousFieldOrDatumDef(encoding[channel])) {
          delete size[sizeType];
          log.warn(log.message.stepDropped(sizeType));
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return size;
}